












































































































































































































































































































































































































































































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import axios from 'axios';
import Swal from 'sweetalert2';
import DonorsTab from './DonorsTab.vue';
import RelativeDonorsTab from './RelativeDonorsTab.vue';
import BaseEdit from './BaseEdit';
import ServicesAndBills from '@/components/ServicesAndBills.vue';
import moment from 'moment';
import FileUploader from '@/components/FileUploader.vue';

@Component({
  components: {
    'donors-tab': DonorsTab,
    'relative-donors-tab': RelativeDonorsTab,
    'services-and-bills': ServicesAndBills,
    'file-uploader': FileUploader,
  },
})
export default class Edit extends BaseEdit {
  @Prop({ default: null })
  public query: any;

  public STATUS_PROJECT = 1;
  public STATUS_FAMILY_SYRVEY = 9;
  public STATUS_CENTER_REJECT = 6;
  public STATUS_RDKM_REJECT = 7;
  public STATUS_RELATIVE_DONOR = 10;
  public STATUS_ACTIVATION = 4;
  public STATUS_COMPLETE = 5;
  public REJECT_STATUSES = [6, 7];

  public form = {
    comment: '',
    registerComment: '',
    coordinatorNotes: '',
    diagnosisId: '',
    statuses: [],
    genders: [],
    gendersLocalized: [],
    diagnoses: [],
    bloodTypes: [],
    cmvStatuses: [],
    rhs: [],
    hlas: [],
    donorsAtWork: [],
    operators: [],
    operatorsData: [],
    operatorEmail: '',
    operatorPhone: '',
    operatorAdphone: '',
    services: [],
    patientServices: [],
    patientBills: [],
    number: '',
    service: '',
    сreateUserPhone: '',
    сreateUserAdphone: '',
  } as any;

  public tabIndex: any = 0;

  public init = false;
  public moment = moment;

  get isDonorTabVisible() {
    return !this.form.isNew && (!this.isRelativePatient ||
           [ this.STATUS_RELATIVE_DONOR, this.STATUS_ACTIVATION, this.STATUS_COMPLETE ].indexOf(this.form.status) >= 0);
  }

  public statusOrder(status) {
    if (this.isRelativePatient) {
      return [ this.STATUS_PROJECT, this.STATUS_FAMILY_SYRVEY,
               this.STATUS_RELATIVE_DONOR, this.STATUS_ACTIVATION, this.STATUS_RDKM_REJECT ].indexOf(status);
    }
    return status;
  }

  public tryChangeStatus(newStatus: any) {
    if (this.form.status === newStatus) {
      return;
    }
    if (this.statusOrder(this.form.status) > this.statusOrder(newStatus) || this.REJECT_STATUSES.includes(newStatus)) {
      // @ts-ignore
      const newStatusName = this.form.statuses.filter((s) => s.key == newStatus)[0].value;
      let msgText =
        '<span style="color:black; font-size: 18px">Это действие отменит текущий статус. <br/>Будет выставлен предыдущий статус <b>"' +
        newStatusName +
        '"</b>. <br/>Выполнить операцию?</span>';
      if (this.REJECT_STATUSES.includes(newStatus)) {
        msgText =
          '<span style="color:black; font-size: 18px">Вы действительно хотите сделать <span style="color:red">ОТКАЗ</span>? <br/>В результате будет выставлен статус <b>"' +
          newStatusName +
          '"</b>. <br/> Выполнить операцию?</span>';
      }
      const msgHtml = document.createElement('div');
      msgHtml.innerHTML = msgText;
      // @ts-ignore
      this.$swal({
        icon: 'warning',
        title: this.$t('Предупреждение'),
        content: msgHtml,
        buttons: [this.$t('Нет'), this.$t('Да')],
      }).then((doChange: any) => {
        if (doChange) {
          this.form.status = newStatus;
        }
      });
    } else {
      this.form.status = newStatus;
    }
  }

  @Watch('form.status')
  public async onStatusChanged(val: number, oldVal: number) {
    if (!this.isDataLoaded || oldVal === 0 || oldVal == null) {
      return;
    }
    await this.submitWithFile('/patients', false);
    if (this.isStatusChangeError) {
      this.form.status = oldVal;
    }
  }

  @Watch('form.operatorId')
  public onOperatorIdChanged(val: string, oldVal: string) {
    const operator = this.form.operatorsData.find((column: any) => column.id == val);
    this.form.operatorName = operator ? operator.name : '';
    this.form.operatorEmail = operator ? operator.email : '';
    this.form.operatorPhone = operator ? operator.phone : '';
    this.form.operatorAdphone = operator ? operator.additionalPhone : '';
  }

  @Watch("isDataLoaded")
  onIsDataLoaded() {
    if (this.isDataLoaded && !this.form.operatorId && this.$auth.user().isRdkm) {
      this.form.operatorId = this.$auth.user().id;
    }
  }

  @Watch("form.createUserId")
  onCreateUserIdChanged(val: string, oldVal: string) {
    if (this.init) {
      const tcUser = this.form.tcUsersData.find((column: any) => column.id == val);
      this.form.createUserName = tcUser ? tcUser.name : "";
      this.form.createUserEmail = tcUser ? tcUser.email : "";
      this.form.сreateUserPhone = tcUser ? tcUser.phone : "";
      this.form.сreateUserAdphone = tcUser ? tcUser.additionalPhone : "";
    }
    this.init = true;
  }

  @Watch("form.id")
  onIdChanged(val: string, oldVal: string) {
    if (!this.$auth.user().tcId) {
      axios
        .get("/Dictionary/GetTcOrganizations")
        .then((response) => {
          const tcOrgs = response.data;
          const div = document.createElement("div");
          const select = document.createElement("select");

          select.classList.add("form-control");
          select.id = "tc-select";
          for (let i = 0; i < tcOrgs.length; i++) {
            const option = document.createElement("option");
            option.value = tcOrgs[i].key;
            option.text = tcOrgs[i].value;
            select.appendChild(option);
          }
          div.appendChild(select);
        })
        .catch(() => {});
    }
  }

  get canEditTc() {
    return (
      this.$auth.user().functions.find((t: any) => t.routeName === "ChangeTc") != null
    );
  }

  get organizationUsers() {
    const users = this.form.users
      ? this.form.users
          .filter(
            (t: any) =>
              t.organizationId == this.form.organizationId ||
              t.id == this.form.createUserId
          )
          .map((t: any) => {
            return { key: t.id, value: t.name };
          })
      : [];
    return [...new Map(users.map(item => [item['key'], item])).values()];
  }

  get isSearchDonorStatus() {
    return this.statusIn(["Поиск донора"]);
  }

  get isServicesAndBillsVisible() {
    return this.statusIn([
      "Семейное обследование",
      "Работа с родственным донором",
      "Запрос на заготовку",
      "Донор подобран",
      "Активация донора",
      "Поиск донора",
    ]);
  }

  get contactTC() {
    return `${this.form.createUserName || ""}, ${this.form.createUserEmail || ""}, ${
      this.form.сreateUserPhone
    }, ${this.form.сreateUserAdphone}`;
  }

  get contactRDKM() {
    let operator = "";

    if (this.form.operatorId) {
      let operators = this.form.operators.filter(
        (item: { key: any }) => item.key === this.form.operatorId
      );
      operator += `${operators && operators.length && operators[0].value}`;
    }

    return `${operator}, ${this.form.operatorEmail}, ${this.form.operatorPhone}, ${this.form.operatorAdphone}`;
  }

  emailNotificationHandler() {
    var errors = "";

    if (!this.form.lastName) errors += "</br><strong>" + this.$t("Фамилия") + "</strong>";
    if (!this.form.firstName) errors += "</br><strong>>" + this.$t("Имя") + "</strong>";
    if (!this.form.middleName)
      errors += "</br><strong>" + this.$t("Отчество") + "</strong>";
    if (!this.form.birthday)
      errors += "</br><strong>" + this.$t("Дата рождения") + "</strong>";

    if (errors) {
      this.highlightAllLabels(errors);
      Swal(
        this.$t("Предупреждение") as string,
        this.$t(
          "Нельзя установить режим оповещения без указания `Ф. И. О. пациента`, `Даты рождения`"
        ) as string,
        "warning"
      );
    } else {
      this.form.isEmailNotification = !this.form.isEmailNotification;
      if (this.form.isEmailNotification) {
        Swal(
          this.$t("Информация") as string,
          this.$t("Был включен режим оповещения!") as string,
          "info"
        );
        if (!this.form.emailNotificationDate) {
          let nowDate: Date = new Date();
          nowDate.setMonth(nowDate.getMonth() + 3);
          this.form.emailNotificationDate = nowDate;
        }
      } else {
        Swal(
          this.$t("Информация") as string,
          this.$t("Был выключен режим оповещения!") as string,
          "info"
        );
        this.form.emailNotificationDate = null;
      }
    }
  }

  async submitWithFile(path: any, isGoHome = false, routeBackName: any = "") {
    let formData = new FormData();
    formData.append("json", JSON.stringify(this.form));

    await this.submit(
      path,
      isGoHome,
      routeBackName,
      formData,
      this.showStatusChangeError
    );
  }

  showStatusChangeError(e: any) {
    Swal(this.$t("Ошибка") as string, e.data.message, "warning");
  }

  get emailNotificationLabel() {
    return this.form.isEmailNotification ? this.$t("Активен") : this.$t("Не активен");
  }

  get emailNotificationVariant() {
    return this.form.isEmailNotification ? "danger" : "primary";
  }
}
